import React, {useEffect, useRef, useState} from "react";
import {Form, Input, Modal} from "antd";

import {getActiveAccount} from "../../lib/activeMember";
import {updateAccount} from "../../helpers/account";
import {messageType, showMessages} from "../../helpers/message";

import {formStandaloneLayout} from "../../assets/styles";
import {accountDetailsUpdated, nothingToUpdate} from "../../helpers/text";

const AccountFriendlyNameEdit = ({friendlyNameProp, handleClose, visible}) => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const [friendlyName, setFriendlyName] = useState(friendlyNameProp);
    const [loading, setLoading] = useState(false);

    const handleFinish = async () => {
        if (friendlyNameProp === friendlyName) {
            showMessages(nothingToUpdate, messageType.error);
            return;
        }

        try {
            setLoading(true);
            const abortSignal = abortSignalRef.current;
            const account = getActiveAccount();
            if (!account) {
                showMessages('Could not load account information', messageType.error);
                return;
            }

            const body = {friendly_name: friendlyName};
            await updateAccount(account.id, body, abortSignal);
        } catch (error) {
            showMessages(error.message, messageType.error);
        } finally {
            showMessages(accountDetailsUpdated, messageType.success);
            setLoading(false);
            handleClose();
        }
    };

    // Cleanup effect when component unmounts
    useEffect(() => {
        const abortController = abortControllerRef.current;
        return function abort() {
            abortController.abort();
        }
    }, []);

    return (
        <Modal
            title="Additional Details"
            open={visible}
            onOk={handleFinish}
            onCancel={() => handleClose(false)}
            okText="Save"
            okButtonProps={{loading}}
        >
            <Form
                {...formStandaloneLayout}
                onFinish={handleFinish}
                initialValues={{"friendly_name": friendlyName}}
            >
                <Form.Item
                    name="friendly_name"
                    label="Friendly Name"
                >
                    <Input
                        placeholder="Enter friendly name"
                        onChange={(e) => setFriendlyName(e.target.value)}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default AccountFriendlyNameEdit;
